/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCDownIcon20Light = forwardRef('ArrowCDownIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M16.603 7.021a.5.5 0 0 1 0 .708l-4.836 4.836a2.5 2.5 0 0 1-3.535 0L3.396 7.729a.5.5 0 0 1 .707-.708l4.836 4.836a1.5 1.5 0 0 0 2.121 0l4.836-4.836a.5.5 0 0 1 .707 0Z" })));
});
